import mapTypeToTemplate from './mapTypeToTemplate';

/**
 * Returns a callback that maps available type options in results
 * to the type select component.
 * @param {Element} component
 * @param {Element[]} results
 * @param {jQuery} $itemTemplate
 * @return {Function} A callback function
 */
const handleTypes = (component, results, $itemTemplate) => () => {
    const $list = $(component).find('.downloads-list__type .select__list');

    const availableTypes = Object.keys(results.reduce((obj, entry) => {
        const types = $(entry).attr('data-downloadtype').split(',').filter(str => str);
        $(types).each((_, type) => {
            obj = { ...obj, [type]: true };
        });
        return obj;
    }, {}));
    const items = mapTypeToTemplate(availableTypes, $itemTemplate);

    $list.empty().append(items);
};

export default handleTypes;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/handleTypes.js